import { useState } from "react";
import { X, Sparkles } from "lucide-react";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";

const PORTAL_MAP = {
  India: { domain: "Indias.com", flag: "🇮🇳" },
  "United States of America": { domain: "USAPulse.net", flag: "🇺🇸" },
  "United States": { domain: "USAPulse.net", flag: "🇺🇸" },
};

export default function CountryNudge() {
  const { user } = useAuth();
  const { tr } = useI18n();
  const [dismissed, setDismissed] = useState(false);

  const portal = user?.preferred_country ? PORTAL_MAP[user.preferred_country] : null;
  if (!portal || dismissed) return null;

  const explore = () => {
    window.dispatchEvent(new CustomEvent("wp:select-country", { detail: user.preferred_country }));
  };

  return (
    <div data-testid="country-nudge-banner" className="bg-gradient-to-r from-[#EAF2FD] via-[#F0FDF4] to-[#FFF7ED] border-b border-[#DCE8F7]">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-2.5 flex items-center gap-3">
        <Sparkles size={16} className="text-[#EA580C] shrink-0" />
        <p className="text-sm text-[#0F2557] flex-1">
          <span className="mr-1">{portal.flag}</span>
          {tr("Your home country has its own dedicated portal —")}{" "}
          <button data-testid="country-nudge-cta" onClick={explore} className="font-extrabold text-[#2563EB] hover:text-[#1D4ED8] underline underline-offset-2">
            {tr("Explore")} {portal.domain} →
          </button>
        </p>
        <button data-testid="country-nudge-dismiss" onClick={() => setDismissed(true)} className="p-1 text-[#64748B] hover:text-[#0F2557]">
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
